import { Injectable } from '@angular/core';

import { Occ, OccConfig, Product, ProductNameNormalizer } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class CustomProductNameNormalizer extends ProductNameNormalizer {
  constructor(protected config: OccConfig) {
    super(config);
  }

  convert(source: Occ.Product, target?: Product): Product {
    target = target ?? { ...(source as unknown as Partial<Product>) };

    if (!!source && source.name) {
      target.name = super.normalize(source.name);
      target.slug = super.normalizeSlug(source.name);
      target.nameHtml = source.name;
    }
    return target as Product;
  }
}
